export const home = {
  GET_DATA: "HOME_GET_DATA",
  GET_DATA_RECEIVED: "HOME_GET_DATA_RECEIVED",
};

export const main = {
  SET_USERS_ACCOUNTS: "MAIN_SET_USERS_ACCOUNTS",
  SET_USER_DATA: "MAIN_SET_USER_DATA",
  SET_USER_PROFILE: "MAIN_SET_USER_PROFILE",
  SET_USER: "MAIN_SET_USER",
};
